import script from "./SocialMediaOpinion.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialMediaOpinion.vue?vue&type=script&setup=true&lang=js"

import "./SocialMediaOpinion.vue?vue&type=style&index=0&id=b37b075e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b37b075e"]])

export default __exports__